<div style="height: 100%; width: 100%;">
    <canvas *ngIf="dataLoaded" id="coaching-pie-chart" baseChart width="400px" height="225px" [type]="chartConfig.type"
        [legend]="false" [datasets]="chartConfig.data.datasets" [labels]="chartConfig.data.labels"
        [options]="chartConfig.options" [plugins]="chartConfig.plugins">
    </canvas>
</div>